module.exports = __webpack_public_path__ + "static/img/r-1-2.c9d0fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/r-1-2.png
// module id = qdEL
// module chunks = 0